import Notifications from '@/components/community_settings/notifications/Notifications';

export default {
    key: 'notifications',
    title: 'notification',
    component: Notifications,
    permissionChecker: () => true, // TODO: Needs permission?
};
